import { render, staticRenderFns } from "./NotificationsLink.vue?vue&type=template&id=19569d5a&scoped=true"
import script from "./NotificationsLink.vue?vue&type=script&lang=js"
export * from "./NotificationsLink.vue?vue&type=script&lang=js"
import style0 from "./NotificationsLink.vue?vue&type=style&index=0&id=19569d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19569d5a",
  null
  
)

export default component.exports